// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculatorInput":"_1RqzBA","holder":"_1_6R6P","inputBox":"_6ZzEGu","currencyBox":"_1K5-86","infoBtn":"_1BBlOD","iconWrapper":"_1ZY4hy"};